import React from "react";
import { Building2, Users, Truck, ShieldCheck } from "lucide-react";

const STYLES = {
  forwarder: {
    bg: "rgba(24,95,165,0.15)",
    border: "rgba(24,95,165,0.4)",
    color: "#79b5f0",
    Icon: Building2,
    label: "FORWARDER",
  },
  customer: {
    bg: "rgba(155,89,182,0.15)",
    border: "rgba(155,89,182,0.4)",
    color: "#c89adb",
    Icon: Users,
    label: "CUSTOMER",
  },
  carrier: {
    bg: "rgba(243,177,74,0.15)",
    border: "rgba(243,177,74,0.4)",
    color: "#f3b14a",
    Icon: Truck,
    label: "CARRIER",
  },
  internal: {
    bg: "rgba(39,174,96,0.12)",
    border: "rgba(39,174,96,0.4)",
    color: "#4ed084",
    Icon: ShieldCheck,
    label: "INTERNAL",
  },
};

export const TenantTypeChip = ({ tenantType, viewTier, compact = false }) => {
  // Use view_tier as primary (it's the security-relevant value); fall back to
  // tenant_type. Platform admins always read as "internal".
  const key = (viewTier === "internal" && tenantType === "forwarder") ? "forwarder" : (viewTier || tenantType || "forwarder");
  const cfg = STYLES[key] || STYLES.forwarder;
  const { Icon } = cfg;
  return (
    <div
      className="flex items-center gap-1.5 rounded-full"
      style={{
        padding: compact ? "2px 7px" : "3px 9px",
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        color: cfg.color,
        fontFamily: "DM Mono, monospace",
        fontSize: compact ? 9 : 10,
        letterSpacing: "1.2px",
        fontWeight: 600,
      }}
      data-testid="tenant-type-chip"
      data-tenant-type={tenantType}
      data-view-tier={viewTier}
      title={`Tenant type: ${tenantType} · View tier: ${viewTier}`}
    >
      <Icon size={compact ? 10 : 11} />
      <span>{cfg.label}</span>
    </div>
  );
};

export default TenantTypeChip;
